module.exports = __webpack_public_path__ + "img/rambursari-tichete.e6944161.svg";